// ---- Data check (Accounts page, owner only): every inconsistency in everyone's data
/** The section's title. Empty hides the whole section. */
export const CHECK_TITLE = "Data check";
/** While it runs. */
export const CHECK_RUNNING = "Checking everyone's data…";
/** When nothing is wrong. */
export const CHECK_OK = "No problems found";
/** {count} problems. */
export const CHECK_PROBLEMS = "{count} to fix";
/** Copies the full report (who is who, every total from both sides, every problem) to paste to Claude. */
export const CHECK_COPY = "Copy report for Claude";
export const CHECK_COPIED = "Report copied. Paste it to Claude.";
export const CHECK_COPY_FAILED = "Couldn't copy here. Try on another browser.";
export const CHECK_AGAIN = "Check again";
